import { useEffect, useState } from "react";
import {
	buildSessionId,
	getOrCreateProviderIdentifier,
	injectFingerprint,
} from "./fingerprint";

/**
 * Loads the Cybersource / ThreatMetrix device fingerprint collector when the
 * retailer has it enabled, and returns the generated ProviderIdentifier so it
 * can later be sent along with the fraud analysis request.
 *
 * @param {object} configuration - retailer.configuration from the order response
 * @param {string} orderCode - order id used to key the persisted identifier
 * @returns {string|null} the ProviderIdentifier, or null when the SDK is inactive
 */
export function useCybersourceFingerprint(configuration, orderCode) {
	const [providerIdentifier, setProviderIdentifier] = useState(null);

	const enabled = Boolean(configuration?.enableSdkCybersource);
	const { orgId, prefixToken, fingerprintServer } =
		configuration?.sdkCybersourceConfiguration ?? {};

	useEffect(() => {
		if (!enabled || !orderCode) return undefined;

		if (!orgId) {
			console.warn(
				"[Cybersource] enableSdkCybersource=true mas orgId ausente; SDK não ativado"
			);
			return undefined;
		}

		const identifier = getOrCreateProviderIdentifier(orderCode);
		const cleanup = injectFingerprint({
			orgId,
			prefixToken,
			fingerprintServer,
			providerIdentifier: identifier,
		});
		setProviderIdentifier(identifier);

		if (process.env.NODE_ENV === "development") {
			console.log(
				`[Cybersource] ProviderIdentifier: ${identifier} | session_id: ${buildSessionId(
					prefixToken,
					identifier
				)}`
			);
		}

		return cleanup;
	}, [enabled, orgId, prefixToken, fingerprintServer, orderCode]);

	return providerIdentifier;
}
